var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calculator__form"},[_c('h4',[_vm._v(_vm._s(_vm.translations?.title))]),_vm._v(" "),(_vm.translations?.description)?_c('p',[_vm._v(_vm._s(_vm.translations.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }